module.exports = __webpack_public_path__ + "img/beautify8.ceeae7f7.webp";